import { liveUsageMgmtSliceSelector } from "./liveUsageMgmtSliceSelector";
import { RootState } from "@/store/store";

export const liveUsageMgmtIsPageLoadingSelector = (state: RootState): boolean =>
  liveUsageMgmtSliceSelector(state).isPageLoading;
